var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMiddlecircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 264,
    height: 828,
    viewBox: "0 0 264 828",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M528.717 22.9951C477.058 5.23359 422.866 -1.94683 369.235 1.8638C315.603 5.67443 263.583 20.4016 216.145 45.2042C168.706 70.0067 126.778 104.399 92.7544 146.418C58.7307 188.436 33.2776 237.258 17.8484 290.096C2.41927 342.933 -2.68374 398.752 2.83066 454.364C8.34506 509.977 24.3689 564.295 49.9873 614.216C75.6058 664.137 110.317 708.684 152.139 745.313C193.962 781.943 242.076 809.937 293.735 827.699L348.148 641.358C320.414 631.822 294.583 616.793 272.13 597.128C249.677 577.462 231.041 553.546 217.287 526.745C203.534 499.944 194.931 470.782 191.97 440.926C189.01 411.069 191.749 381.101 200.033 352.734C208.316 324.367 221.981 298.156 240.248 275.598C258.514 253.039 281.024 234.575 306.493 221.259C331.961 207.943 359.889 200.037 388.682 197.991C417.475 195.945 446.569 199.8 474.304 209.336L528.717 22.9951Z",
    fill: "#3162AC"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 359,
    cy: 425,
    r: 206,
    fill: "#FF2200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiddlecircle);
export default __webpack_public_path__ + "static/media/Middlecircle.c403bac02252f13e61993a903dd97e8b.svg";
export { ForwardRef as ReactComponent };